import {Component, input} from '@angular/core';
import {EvaluationSubCriteriaDirectus} from '@frontend/directus';
import {SubCriteriaAttributeItem} from '../../../subcriteria-attribute-evaluation/subcriteria-attribute-evaluation.types';
import {
  BarChartConfig,
  ProgressDashboardGenericBarChartComponent,
} from '../progress-dashboard-generic-bar-chart.component';

const SC_BAR_CHART_CONFIG: BarChartConfig<EvaluationSubCriteriaDirectus> = {
  getNumberFromAttribute: (attribute) => attribute.scNumber,
  findCriteriaByNumber: (criteria, number) => criteria.find((sc) => sc.sc_number === number),
  getTranslations: (criteria) => criteria.translations,
  sortDescending: false,
};

@Component({
  selector: 'app-progress-dashboard-rfi-bar-chart-container',
  imports: [ProgressDashboardGenericBarChartComponent],
  template: `
    <app-progress-dashboard-generic-bar-chart
      [label]="label()"
      [subCriteriaAttributes]="subCriteriaAttributes()"
      [criteria]="subEvaluationCriteria()"
      [config]="chartConfig"
    />
  `,
})
export class ProgressDashboardRfiBarChartComponent {
  readonly label = input.required<string>();
  readonly subCriteriaAttributes = input.required<SubCriteriaAttributeItem[]>();
  readonly subEvaluationCriteria = input.required<EvaluationSubCriteriaDirectus[]>();

  protected readonly chartConfig = SC_BAR_CHART_CONFIG;
}
